/**
 * Config types shown on the Config page and how each one uses "Page Url".
 *
 * - pageUrlHint: Page Url is entered by the user; the website looks the record up by it.
 * - fixedPageUrl: the website always reads this exact Page Url, so the field is hidden and this value is saved.
 * - defaultPageUrl: the website ignores Page Url (it reads the latest active record), so the field is hidden;
 *   new records get this value and existing records keep theirs.
 * - template: starter JSON for a new record.
 */
export const CONFIG_TYPES = [
    { value: 'metadata-config', label: 'Meta Data', pageUrlHint: 'Page key the meta tags apply to, e.g. home, products, cart, or a custom/deals page url' },
    { value: 'home-page-config', label: 'Home Page', fixedPageUrl: 'home' },
    { value: 'footer-config', label: 'Footer Page', fixedPageUrl: 'footer' },
    { value: 'custom-page-config', label: 'Custom Page', pageUrlHint: 'Opens on the website at /p/<page url>' },
    { value: 'logic-page-config', label: 'Logic Page', pageUrlHint: 'Opens on the website at /deals/<page url>' },
    { value: 'notification-bar-config', label: 'Notification Bar', defaultPageUrl: 'notification-bar' },
    {
        value: 'menu-config',
        label: 'Menu',
        defaultPageUrl: 'menu',
        // "categories": true fills that item's sub-menu from the store's categories
        template: {
            enabled: true,
            items: [
                { label: 'Shop All', url: '/products' },
                { label: 'Shop by Category', url: '/products', categories: true },
                {
                    label: 'Collections',
                    url: '',
                    children: [
                        { label: 'New Arrivals', url: '/products' },
                        { label: 'Best Sellers', url: '/products' },
                    ],
                },
                { label: 'Contact', url: '/contact' },
            ],
        },
    },
    {
        value: 'listing-page-config',
        label: 'Product Listing',
        fixedPageUrl: 'products',
        template: { categoryFilter: true, priceFilter: true },
    },
];

export const getConfigType = (value) => CONFIG_TYPES.find((type) => type.value === value) || null;

/** True when Page Url is not entered by the user for this config type. */
export const isPageUrlHidden = (type) => Boolean(type && (type.fixedPageUrl || type.defaultPageUrl));
